import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import Checkbox from 'rc-checkbox';

const DateRangeFieldCheckbox = ({ input, label, value }) => {
    return (
        <div className="date-range__checkbox">
            <label className="date-range__bc">
                <Checkbox {...input} checked={!!input.value}
                    prefixCls="checkbox--regular"/>
                {label}
            </label>
        </div>
    );
};

DateRangeFieldCheckbox.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(DateRangeFieldCheckbox);



// WEBPACK FOOTER //
// ./src/components/date-range/DateRangeFieldCheckbox.js